import { Modal } from './Modal';
import { Button } from './Button';
import { Alert } from './Alert';

interface ConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: string;
  confirmLabel?: string;
  tone?: 'danger' | 'primary';
  isLoading?: boolean;
  error?: string | null;
}

// Generic yes/no confirmation dialog, used wherever an action needs a
// deliberate second step before firing (deactivating an org/site/user,
// reactivating one, etc.) - built once here rather than duplicated inline
// across CustomersListPage/CustomerDetailPage.
export function ConfirmModal({
  open,
  onClose,
  onConfirm,
  title,
  description,
  confirmLabel = 'Confirm',
  tone = 'danger',
  isLoading,
  error,
}: ConfirmModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      size="sm"
      footer={
        <>
          <Button variant="secondary" onClick={onClose} type="button" disabled={isLoading}>
            Cancel
          </Button>
          <Button variant={tone} onClick={onConfirm} isLoading={isLoading}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-3">
        {error && <Alert tone="error">{error}</Alert>}
        <p className="text-sm text-slate-600">{description}</p>
      </div>
    </Modal>
  );
}
